import { unionBy } from 'lodash-es';
import { useEffect } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import type { UpsertInsInsightOutcomeDTO } from '../../../server/dto/ins-insight-outcome-dto.ts';
import type { LogInteractionFormValues } from '../components/log-interaction-dialog.tsx';

type UseLogInteractionInsights = {
    stagedInsInsightOutcomes: UpsertInsInsightOutcomeDTO[];
    upsertInsInsightOutcome: (insightOutcome: UpsertInsInsightOutcomeDTO) => void;
    removeInsInsightOutcome: (insightId: string) => void;
};

export function useLogInteractionInsights(
    form: UseFormReturn<LogInteractionFormValues>,
): UseLogInteractionInsights {
    const { watch, setValue } = form;

    const customerId = watch('customerId');
    const insInsightOutcomes = watch('insInsightOutcomes');

    useEffect(() => {
        setValue('insInsightOutcomes', []);
    }, [customerId, setValue]);

    const upsertInsInsightOutcome = (insInsightOutcome: UpsertInsInsightOutcomeDTO): void => {
        const updatedArr = unionBy([insInsightOutcome], insInsightOutcomes, (o) => o.insightId);

        setValue('insInsightOutcomes', updatedArr, { shouldDirty: true });
    };

    const removeInsInsightOutcome = (insightId: string): void => {
        setValue(
            'insInsightOutcomes',
            insInsightOutcomes.filter((o) => o.insightId !== insightId),
            { shouldDirty: true },
        );
    };

    return {
        upsertInsInsightOutcome,
        removeInsInsightOutcome,
        stagedInsInsightOutcomes: insInsightOutcomes,
    };
}
